
import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'

import JobTitlesForm from './JobTitlesForm.vue'
import OrgForm from './OrgForm.vue'
import BlueButton from '../Atomic/BlueButton.vue'
import GreenButton from '../Atomic/GreenButton.vue'
import RedButton from '../Atomic/RedButton.vue'
import CardTitle from '../Atomic/CardTitle.vue'

import { Organisation } from '@/models/organisation'

import OrganisationsService from '../../services/OrganisationsService'
import {INotificationService} from '../../services/NotificationService'
import ErrorHandlerService from '@/services/ErrorHandlerService'

import { sortStringValues } from '../../utils/utils'
import {OrganisationJobTitle} from '@/models/organisationJobTitle'
import ProgressLinear from '@/components/Atomic/ProgressLinear.vue'

@Component({
  components: {
    BlueButton,
    GreenButton,
    RedButton,
    CardTitle,
    JobTitlesForm,
    OrgForm,
    ProgressLinear,
  },
})

export default class CreateOrganisation extends Vue {
@Prop() public readonly orgs!: Organisation[]
@Prop() public readonly titles!: OrganisationJobTitle[]
@Prop(Function) public readonly onDialogClose!: () => void

private errorHandlerService: ErrorHandlerService
private $notificationService!: INotificationService

private organisation: Organisation = new Organisation(0, '', '', '', '', '', [], false)
private jobTitles: string[] = []
private orgJobTitles: string[] = []
private dialog: boolean = false
private isPending: boolean = false

private stepNumber: number = 1

constructor() {
  super()
  this.errorHandlerService = new ErrorHandlerService()
}

private mounted() {
}

private async create() {
  this.isPending = true
  const validated = await this.$validator.validateAll()
  if (validated) {
    try {
      await OrganisationsService.create(this.organisation)
      this.$notificationService.success(this.$t('EXTRAS.OrganisationCreated').toString())
      this.onDialogClose()
      this.resetDialog()
    } catch (error: any) {
      this.errorHandlerService.handle(this, error.response.data.code, true)
    }
  }
  this.isPending = false
}

private resetDialog() {
  this.organisation = new Organisation(0, '', '', '', '', '', [], false)
  this.stepNumber = 1
  this.dialog = false
}

private previous() {
  this.stepNumber = 1
}

  private async next() {
    const validated = await this.$validator.validateAll()
    if (validated) {
      this.stepNumber++
    }
  }

}
